import React from "react";
import DayPickerInput from "react-day-picker/DayPickerInput";
import "react-day-picker/lib/style.css";
import MomentLocaleUtils from "react-day-picker/moment";
import moment from "moment";

class WeekPicker extends React.Component {
  constructor(props) {
    super(props);
    this.handleDayChange = this.handleDayChange.bind(this);
    this.state = {
      selectedDay: undefined,
      isDisabled: false,
    };
  }

  handleDayChange(selectedDay) {
    this.props.name === "date" ? this.props.handleChange(selectedDay) : "";
    this.props.name === "admindate" ? this.props.setDate(selectedDay) : "";
  }

  render() {
    const { selectedDate, disabledDays } = this.props;
    return (
      <div>
        <DayPickerInput
          value={selectedDate}
          onDayChange={this.handleDayChange}
          dayPickerProps={{
            selectedDays: [selectedDate],
            disabledDays: { before: new Date(), daysOfWeek: disabledDays },
            locale: moment.locale(),
            localeUtils: MomentLocaleUtils,
          }}
          placeholder="Select Date"
          name={this.props.name}
          keepFocus={false}
          inputProps={{readOnly:true}}
        />
      </div>
    );
  }
}

export default WeekPicker;



// WEBPACK FOOTER //
// ./components/customDateTimePicker/CustomDateTimePicker.js